import React from 'react';
import CalculationEditor from './CalculationEditor';

export default (props) => (
  <CalculationEditor
    {...props}
    previewMode
  />
);
